import type { Theme } from 'paymentiq-cashier-bootstrapper';

export const piqTheme: Theme = {
  cashierbackground: {
    color: 'var(--background-body)'
  },
  buttons: {
    color: '#FFB400'
  },
  headings: {
    color: '#03110D'
  },
  labels: {
    color: 'var(--components-input-fg-primary, #0A0A0A)'
  },
  border: {
    radius: '999px'
  },
  loader: {
    color: '#F62828'
  },
  input: {
    color: '#03110D',
    fontSize: '14px',
    height: '56px',
    borderRadius: '56px'
  },
  inputbackground: {
    color: 'transparent'
  },
  margin: {
    size: '16px'
  }
};
